type HryvniaIconProps = React.SVGProps<SVGSVGElement> & {
	rotate?: number;
};

function HryvniaIcon({ rotate = 0, ...props }: HryvniaIconProps) {
	return (
		<svg
			width="30"
			height="40"
			viewBox={rotate ? "-4 -3 38 46" : "0 0 30 40"}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g transform={rotate ? `rotate(${rotate} 15 20)` : undefined}>
				<path
					d="M21.0415 18.0469L16.4218 21.9531H29.9906V26.25H12.3921C11.2184 27.1745 10.5192 28.3008 10.5192 29.7363C10.5192 32.1973 12.3921 33.5319 15.7351 33.5319C18.585 33.5319 21.0415 32.0996 23.008 29.1276L28.405 32.9232C25.4615 37.6432 20.1457 40 15.1295 40C8.54021 40 3.63022 36.722 3.63022 31.2858C3.63506 29.4461 4.2605 27.6669 5.39694 26.2598H0L0 21.9531H8.64946L13.3722 18.0469H0L0 13.75H17.5018C18.7816 12.5228 19.3747 11.3932 19.3747 10.0586C19.3747 7.91016 17.5018 6.37044 14.652 6.37044C11.8957 6.37044 9.54219 7.99805 7.86599 10.7747L2.65321 7.07682C5.50619 2.35677 10.1259 0 15.142 0C21.9249 0 26.3479 3.69141 26.3479 8.71419C26.3553 10.5203 25.8084 12.2815 24.7872 13.7402H30V18.0469H21.0415Z"
					fill="currentColor"
				/>
			</g>
		</svg>
	);
}

export default HryvniaIcon;
